import {
  Component,
  Input,
  ChangeDetectionStrategy,
  input,
  inject,
} from "@angular/core";
import { ErrorResponseDTO } from "../../apiModule";
import { TranslocoPipe } from "@jsverse/transloco";
import { ModalRef } from "quang/overlay/modal";

@Component({
  selector: "app-error-modal",
  templateUrl: "./error-modal.component.html",
  styleUrls: ["./error-modal.component.scss"],
  imports: [TranslocoPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ErrorModalComponent {
  private readonly modalRef = inject(ModalRef)
  error = input<ErrorResponseDTO>()

  private static readonly AMBIGUOUS_ERROR_CODES = new Set(["RESOURCE_NOT_ACCESSIBLE"]);

  get errorMessage() {
    const errorCode = this.error()?.errorCode;
    if (errorCode && ErrorModalComponent.AMBIGUOUS_ERROR_CODES.has(errorCode)) {
      const type = this.error()?.type;
      const suffix = type === "PermissionError" ? "PERMISSION" : "VALIDATION";
      return `${errorCode}_${suffix}`;
    }

    return (
      errorCode ||
      this.error()?.message ||
      (this.error() as any)?.statusText ||
      "unknown_error"
    );
  }

  close() {
    this.modalRef.close()
  }
}
